import { Link } from 'react-router';
import { Box, styled } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import ErrorBoundary from '../../components/ErrorBoundary';
import { LocaleIcon, SymbolIcon } from '../../components/icons';
import { setLocale } from '../../i18n';

const StyledLink = styled(Link)(({ theme }) => ({
    display: 'block',
    fontSize: '12px',
    textAlign: 'center',
    fontWeight: 'bold',
    lineHeight: '16px',
    textTransform: 'uppercase',
    cursor: 'pointer',
    color: theme.bino.color.white,
    '&:hover': {
        textDecoration: 'underline',
    },
    marginBottom: 8,
}));

const SectionTitle = styled('div')(({ theme }) => ({
    color: theme.bino.color.palePurple,
    textAlign: 'center',
    height: 24,
    fontSize: 12,
    fontWeight: 'bold',
    lineHeight: 2,
    marginBottom: 24,
    textTransform: 'uppercase',
}));

export const PageFooter = () => {
    const year = new Date().getUTCFullYear();

    return (
        <ErrorBoundary>
            <Box
                component="footer"
                data-testid="test-page-footer"
                sx={(theme) => ({
                    backgroundColor:
                        theme.palette.mode === 'light'
                            ? theme.bino.color.darkerPurple
                            : theme.palette.background.paper,
                    color: theme.bino.color.white,
                    overflow: 'hidden',
                    position: 'relative',
                    marginTop: 'auto', // align to bottom
                })}
            >
                <SymbolIcon
                    sx={(theme) => ({
                        color: theme.bino.color.white,
                        opacity: 0.1,
                        position: 'absolute',
                        width: '60vw',
                        height: '60vw',
                        minWidth: 400,
                        minHeight: 400,
                        transform: `translate(31%, 71%);`,
                        right: 0,
                        bottom: 0,
                        transition: 'transform 0.8s',
                        'footer:hover &': {
                            transform: `translate(31%, 71%) rotate(1deg);`,
                            // transform: `translate(-95%, 71%) rotate(180deg);`,
                        },
                    })}
                />
                <Box
                    sx={{
                        // Without position relative, the absolute positioned symbol covers the links
                        position: 'relative',
                        zIndex: 0,
                        display: 'flex',
                        maxWidth: 850,
                        margin: '80px auto 24px',
                        justifyContent: 'space-evenly',
                    }}
                >
                    <div>
                        <SectionTitle>
                            <LocaleIcon size={24} />
                        </SectionTitle>
                        <StyledLink
                            to={''}
                            onClick={(event) => {
                                event.preventDefault();
                                setLocale('en');
                            }}
                        >
                            <FormattedMessage defaultMessage="English" />
                        </StyledLink>
                        <StyledLink
                            to={''}
                            onClick={(event) => {
                                event.preventDefault();
                                setLocale('sv');
                            }}
                        >
                            <FormattedMessage defaultMessage="Svenska" />
                        </StyledLink>
                    </div>
                    <div>
                        <SectionTitle>BINOSIGHT</SectionTitle>
                        <StyledLink to="/about">
                            <FormattedMessage defaultMessage="About Binosight" />
                        </StyledLink>
                        <StyledLink
                            to="https://binosight.com/integrity-policy"
                            reloadDocument
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <FormattedMessage defaultMessage="Privacy Policy" />
                        </StyledLink>
                    </div>
                    <div>
                        <SectionTitle>
                            <FormattedMessage defaultMessage="Support" />
                        </SectionTitle>
                        <StyledLink
                            to="mailto:support@binosight.com?subject=Support"
                            reloadDocument
                        >
                            <FormattedMessage defaultMessage="Contact" />
                        </StyledLink>
                    </div>
                </Box>
                <Box
                    sx={(theme) => ({
                        textAlign: 'center',
                        marginTop: '40px',
                        marginBottom: '32px',
                        fontSize: 14,
                        lineHeight: '22px',
                        color: theme.bino.color.palePurple,
                    })}
                >
                    {`Copyright © Binosight AB ${year}`}
                </Box>
            </Box>
        </ErrorBoundary>
    );
};
export default PageFooter;
